import { render, staticRenderFns } from "./CustomStoreDialog.vue?vue&type=template&id=06d20d39"
import script from "./CustomStoreDialog.vue?vue&type=script&lang=js"
export * from "./CustomStoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports